<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="OT">Contents</p>
<p class="CON2" id="toc1"><a href="#/Stewart_Envisioning_the_Congregation_text_CC4#_idTOCAnchor-2">Preface</a></p>
<p class="CON2" id="toc2"><a href="#/Stewart_Envisioning_the_Congregation_text_CC5#_idTOCAnchor-3">Acknowledgments</a></p>
<p class="CON1" id="toc3"><a href="#/Stewart_Envisioning_the_Congregation_text_CC6#_idTOCAnchor-4">1. Reimagining the Future of Protestant Congregations</a></p>
<p class="CON1" id="toc4"><a href="#/Stewart_Envisioning_the_Congregation_text_CC7#_idTOCAnchor-5">2. Cultural Impulses in American Congregations</a></p>
<p class="CON1" id="toc5"><span href="#/Stewart_Envisioning_the_Congregation_text_CC8#_idTOCAnchor-6" title="Link target outside of Sample">3. The Gospel in Four Dimensions</span></p>
<p class="CON1" id="toc6"><span href="#/Stewart_Envisioning_the_Congregation_text_CC9#_idTOCAnchor-7" title="Link target outside of Sample">4. On Practices</span></p>
<p class="CON1" id="toc7"><span href="#/Stewart_Envisioning_the_Congregation_text_CC10#_idTOCAnchor-9" title="Link target outside of Sample">5. Practicing the Arts of Belonging: <em class="italic">Koinonia </em></span></p>
<p class="CON1" id="toc8"><span href="#/Stewart_Envisioning_the_Congregation_text_CC11#_idTOCAnchor-11" title="Link target outside of Sample">6. Practicing the Arts of Discipleship: <em class="italic">Mathētēs</em></span></p>
<p class="CON1" id="toc9"><span href="#/Stewart_Envisioning_the_Congregation_text_CC12#_idTOCAnchor-13" title="Link target outside of Sample">7. Practicing the Arts of Witnessing: <em class="italic">Martyria</em></span></p>
<p class="CON1" id="toc10"><span href="#/Stewart_Envisioning_the_Congregation_text_CC13#_idTOCAnchor-15" title="Link target outside of Sample">8. Practicing the Arts of Serving: <em class="italic">Diakonia</em></span></p>
<p class="CON1" id="toc11"><span href="#/Stewart_Envisioning_the_Congregation_text_CC14#_idTOCAnchor-17" title="Link target outside of Sample">9. Practicing the Arts of Worship: <em class="italic">Leitourgia</em><br/><span class="semiboldsc">Part One</span> — Word, Sacraments, Prayer</span></p>
<p class="CON1" id="toc12"><span href="#/Stewart_Envisioning_the_Congregation_text_CC15#_idTOCAnchor-19" title="Link target outside of Sample">10. Practicing the Arts of Worship: <em class="italic">Leitourgia</em><br/><span class="semiboldsc">Part Two</span> — Community, Family, Personal</span></p>
<p class="CON2" id="toc13"><span href="#/Stewart_Envisioning_the_Congregation_text_CC16#_idTOCAnchor-20" title="Link target outside of Sample">Afterword</span></p>
<p class="CON2" id="toc14"><span href="#/Stewart_Envisioning_the_Congregation_text_CC17#_idTOCAnchor-21" title="Link target outside of Sample">Works Cited</span></p>
<p class="CON2" id="toc15"><span href="#/Stewart_Envisioning_the_Congregation_text_CC18#_idTOCAnchor-22" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Stewart_Envisioning_the_Congregation_text_CC3.vue?5b25a6b5